module.exports = __webpack_public_path__ + "static/media/Scene 26.5c378d2c.jpg";